import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';

const BidRequestValueField = props => {
  const { label, value } = props;

  let highlight = false;
  if (label === 'Preferred Term (Years)' && value === 15) {
    highlight = true;
  } else if (label === 'Found home' && value === 'Yes') {
    highlight = true;
  }

  return (
    <Box
      minWidth={170}
      width="50%"
      my={1}
      height={37}
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
    >
      <Typography noWrap variant="subtitle1" color="secondary">
        {label}
      </Typography>
      <Typography noWrap variant="body2" color={highlight ? 'error' : 'primary'}>
        {value}
      </Typography>
    </Box>
  );
};

BidRequestValueField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

BidRequestValueField.defaultProps = {
  value: '--',
};

export default BidRequestValueField;



// WEBPACK FOOTER //
// ./src/sharedComponents/BidRequestInfo/components/BidRequestValueField/BidRequestValueField.js